import React from 'react';
// lodash
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';

import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
  MY_JOHN_LEWIS_TERMS_AND_CONDITIONS,
  SEARCH_UK_POSTCODE_BUTTON,
  POSTCODE,
} from 'jl-design-system/form/fields';
import getAddressFieldsConfig from 'jl-design-system/form/configs/address';
import titleFieldConfig from '../../features/titleDropdownUtil';
import { getPhoneNumberDropdownOptions } from '../../address/addressHelpers';
import { internationalPhoneNumberLazy } from '../../lazy/lazyMainBundle';

const INTERNATIONAL_PHONE_NUMBER = internationalPhoneNumberLazy;

export const TERMS_CONDITIONS_PRIVACY_NOTICE = {
  component: () => (
    <p data-test="termsText">
      By joining you accept the my John Lewis{' '}
      <a
        href="https://www.johnlewis.com/customer-services/shopping-with-us/terms-and-conditions"
        rel="noopener noreferrer"
        target="_blank"
      >terms & conditions
      </a> and our{' '}
      <a
        href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice"
        rel="noopener noreferrer"
        target="_blank"
      >privacy notice
      </a>.
    </p>
  ),
  extra: true,
  name: 'privacy_terms',
};

export const MY_JOHN_LEWIS_ADDRESS_FORM_SIMPLE_ID = 'myJohnLewisAddressFormSimple';

export function getMyJohnLewisAddressFormSimpleConfig() {
  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_SIMPLE_ID,
    submitButton: 'Join My John Lewis',
    fields: [
      MY_JOHN_LEWIS_TERMS_AND_CONDITIONS,
      TERMS_CONDITIONS_PRIVACY_NOTICE,
    ],
  };
}

export const MY_JOHN_LEWIS_ADDRESS_FORM_EDIT_ID = 'myJohnLewisAddressFormEdit';

export function getMyJohnLewisAddressFormEditConfig({
  countryCode,
  addressLines,
  maxAddressLines,
  actions,
  configExtras,
}) {

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
  });

  const config = INTERNATIONAL_PHONE_NUMBER();
  const PHONE_NUMBER = get(config, 'component') ? {
    ...config,
    props: {
      options: getPhoneNumberDropdownOptions(),
    },
  } : config;

  const titleField = titleFieldConfig(configExtras.useTitleDropdown);

  if (!configExtras.useTitleDropdown) {
    titleField.required = false;
    titleField.optional = true;
  }

  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_EDIT_ID,
    submitButton: 'Join My John Lewis',
    fields: [
      {
        ...titleField,
      },
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
      MY_JOHN_LEWIS_TERMS_AND_CONDITIONS,
      TERMS_CONDITIONS_PRIVACY_NOTICE,
    ],
  };
}

export const MY_JOHN_LEWIS_ADDRESS_FORM_NEW_ID = 'myJohnLewisAddressFormNew';

export function getMyJohnLewisAddressFormNewConfig({
  countryCode,
  addressLines,
  maxAddressLines,
  actions,
  configExtras,
  postcodeSearchFormVisible,
}) {

  const { searchForAnotherAddress } = actions;

  const searchForAnotherAddressButton = {
    ...SEARCH_UK_POSTCODE_BUTTON,
    // action: searchForAnotherAddress,
    props: {
      ...SEARCH_UK_POSTCODE_BUTTON.props,
      'data-test': 'search-for-address-button',
      onClick: searchForAnotherAddress,
    },
  };

  const ADDRESS_FIELDS = !postcodeSearchFormVisible ? getAddressFieldsConfig({
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    renderAddressFields: !postcodeSearchFormVisible,
  }) : [];

  const config = INTERNATIONAL_PHONE_NUMBER();
  const PHONE_NUMBER = get(config, 'component') ? {
    ...config,
    props: {
      options: getPhoneNumberDropdownOptions(),
    },
  } : config;

  if (ADDRESS_FIELDS.length > 1) {
    const index = findIndex(ADDRESS_FIELDS, { id: POSTCODE.id });
    if (index >= 0) {
      ADDRESS_FIELDS[index].fieldExtra = searchForAnotherAddressButton;
    }
  }

  const TERMS = postcodeSearchFormVisible ? [] : [
    MY_JOHN_LEWIS_TERMS_AND_CONDITIONS,
    TERMS_CONDITIONS_PRIVACY_NOTICE,
  ];

  const titleField = titleFieldConfig(configExtras.useTitleDropdown);

  if (!configExtras.useTitleDropdown) {
    titleField.required = false;
    titleField.optional = true;
  }

  return {
    id: MY_JOHN_LEWIS_ADDRESS_FORM_NEW_ID,
    submitButton: 'Join My John Lewis',
    fields: [
      {
        ...titleField,
      },
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
      ...TERMS,
    ],
  };
}
